<template>
  <div class="mx-auto flex flex-col gap-x-12 tablet:flex-row laptop:max-w-[800px] desktop:max-w-[1152px]">
    <div
      ref="icons"
      class="group flex max-h-[239px] w-full flex-col items-center text-center text-n400 laptop:h-[239px]"
      v-for="info in data?.companyPage?.data?.attributes?.icons_iconswithtext"
      :key="info?.text || JSON.stringify(info)"
    >
      <CompanyIconTitle :title="info?.text" :image="info?.Icon?.data?.attributes?.url" />
    </div>
  </div>
</template>
<script setup lang="ts">
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { Companypage2DataKey } from "~/symbols/symbols";
import { useWaitForPageTransitionEnd } from "~~/composables/waitPageTransition";

const data = inject(Companypage2DataKey);

const icons = ref<HTMLElement[] | []>([]);

const { promise } = useWaitForPageTransitionEnd();

onMounted(() => {
  initAnimation();
});

let tween = null;
async function initAnimation() {
  await promise.value;

  tween = gsap.from(icons.value, {
    scrollTrigger: {
      trigger: icons.value,
      start: "top 80%",
      end: "bottom 80%",
      scrub: 2,
      once: true,
    },
    y: 20,
    opacity: 0,
    stagger: 0.15,
  });
}

onBeforeUnmount(() => {
  if (tween) {
    tween.kill;
    tween = null;
  }
  // ScrollTrigger.killAll();
});
</script>
<style lang="scss" scoped></style>
